import axios from "axios";
const state = {
    movimientos:[]
};
const getters = {};

const actions = {
    getMovimientos( {commit} ){
        axios
        .get("https://unoweb.uno/api/v1/movimiento/all")
        .then(response => {
            commit('setMovimientos', response.data);
        });
    }
};

const mutations = {
    setMovimientos(state, data){
        state.movimientos = data;
    }
};

export default{
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}